import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {ServiceConfig} from './service-config';
import { InterceptorService } from 'ng2-interceptors';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class ProvinceService {

  private host = ServiceConfig.host;
  public baseUrl = this.host + '/api/province/';
  // public baseUrl = 'http://localhost/api/projects/';
  public data: any;
  public headers: Headers;
  public options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  

  public index(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.post<any>(url,body);
  }

  public getAllProvinces() {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'all?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public getUserByProvinces(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'getUserByProvinces?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public create(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }



  public update(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'update?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public getProvincesByUser(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'getProvincesByUser?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public delete(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/province.service.ts